import React, { useState, useEffect, useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { InputAdornment, TablePagination, Container } from '@material-ui/core';
import axios from 'axios';
import _ from 'lodash';
import { NoDataPlaceholder } from '../components/Placeholders/NoDataPlaceholder';
import { Placeholders } from '../components/Placeholders';
import { StyledSearchIcon } from '../Campaigns/Campaigns.styles';
import { PaginationWrapper } from '../Payments/Payments.styles';
import { ClientType } from './Client/Client.interface';
import {useAuth} from "../context/auth";
import { Client } from './Client';
import {
    TitleRow,
    InputWrapper,
    StyledTextField
} from './Clients.styles';
import { ClientsApiResponse } from './Clients.interface';

export function Clients() {
    const [clients, setClients] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalResults, setTotalResults] = useState(0);
    const { authToken } = useAuth();
    const delayedQuery = useCallback(_.debounce((value, page, rows) => {
        fetchData(value, page, rows);
    }, 500), []);
    const fetchData = (value?: string, page?: number, rows?: number) => {
        let url = '/api/payments/clients/';
        setIsLoading(true);
        if (value){
            url += `?owner=${encodeURIComponent(value)}`
            setIsSearching(true);
        }
        else {
            setIsSearching(false);
        }
        if (page && page !== 0) {
            url += `${url.includes('?') ? '&' : '?'}page=${page + 1}`
        }
        if (rows && rows !== 10) {
            url += `${url.includes('?') ? '&' : '?'}page_size=${rows}`
        }
        axios.get(`${process.env.REACT_APP_BASE_URL}${url}`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            const results = res.data.results.map((client: ClientsApiResponse) => {
                return {
                    ...client,
                    activeCampaigns: client.active_campaigns,
                    availableDovepoints: client.available_points,
                    purchasedDovepoints: client.purchased_dovepoints
                }
            })
            setTotalResults(res.data.count)
            setClients(results);
            setIsLoading(false);
        })
    }
    useEffect(() => {
        setPage(0);
    }, [searchValue])
    useEffect(() => {
        window.scrollTo(0, 0);
        delayedQuery(searchValue, page, rowsPerPage)
    }, [searchValue, page, rowsPerPage])
    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Container>
            <InputWrapper>
                <StyledTextField
                    variant="outlined" 
                    placeholder="Search"
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <StyledSearchIcon />
                            </InputAdornment>
                        )
                    }}
                />
            </InputWrapper>
            {isLoading ? <Placeholders />
                :
                <>
                    {clients.length > 0 ?
                        <>
                            {isMobile ?
                                <>
                                    {clients.map((client: ClientType) => (
                                        <Client key={client.identifier} data={client} refresh={fetchData} />
                                    ))}
                                </>
                                :
                                <>
                                    <TitleRow>
                                        <p>Email</p>
                                        <p>DovePoints Available</p>
                                        <p>DovePoints Purchased</p>
                                        <p>Number of Active Campaigns</p>
                                        <p></p>
                                    </TitleRow>
                                    {clients.map((client: ClientType) => (
                                        <Client key={client.identifier} data={client} refresh={fetchData} />
                                    ))}
                                </>
                            }
                            <PaginationWrapper>
                                <TablePagination
                                    component="div"
                                    count={totalResults}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </PaginationWrapper>
                        </>
                        : <NoDataPlaceholder pageName="Clients" search={isSearching} />

                    }
                </>
            }
        </Container>
    )
}
